/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, ScForm, debug, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 * ScForm.ValidationReturn.js,
	 * ScForm.ClientValidation.js,
	 * ScForm.InvalidField.js
	 */

	'use strict';

	/* globals require, visitor */
	/* jshint maxdepth: 7 */
	/* jshint maxstatements: 39 */

	/* shared by all instances */
	var synchronizedForms = null,
		synchronizedGroups = {};

	var replacePlaceholders = require('lib/ecommerce/Tc.Module.PriceBox').replacePlaceholders;

	function escapeRegExp(string) {
		return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	}

	/**
	 * ScForm module implementation.
	 *
	 * @author Thomas Junghans
	 * @namespace Tc.Module
	 * @class ScForm
	 * @extends Tc.Module
	 */
	Tc.Module.ScForm = Tc.Module.extend({

		//CONSTS
		TPL_PREFIX: '${',
		TPL_SUFFIX: '}',
		TPL_ESCAPED_PREFIX: '$%7B',
		TPL_ESCAPED_SUFFIX: '%7D',
		TEMPLATE_TYPE_HELP_WIDGET: 'Portal Contact-Widget Page',
		TPL_MAP_CUSTOMER_DETAILS_PREFIX: 'customerDetails_',

		//FIELDS
		enableValidationScrolling: true,

		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {

			this.$form = null;

			this.checkboxGroupSelector = '.field[role="group"]';
			this.checkboxSelector = '.custom-checkbox input:checkbox';
			this.selectSelector = '.field select';
			this.radioGroupSelector = '.field[role="radiogroup"]';
			this.radioSelector = '.custom-radio input:radio';
			this.summarySelector = '.scs-form-summary';
			this.saveButtonSelector = '.multipage-save-button';
			this.cancelButtonSelector = '.multipage-cancel-button';
			this.forwardButtonSelector = '.multipage-forward-button';
			this.allInputFieldsSelector = 'input,textarea,select';
			this.formIdSelector = 'input[name=":formid"]';
			this.formStartSelector = 'input[name=":formstart"]';

			// Because FF is auto decoding location.hash string, we are splitting the location.href to achieve same effect
			// https://bugzilla.mozilla.org/show_bug.cgi?id=483304
			this.locationHash = location.href.split('#')[1];


			/**
			 * Holds array of InvalidField
			 *
			 * @property invalidFields
			 * @type {Array<InvalidField>}
			 */
			this.invalidFields = [];
			this.placeholdersData = {};

			//Data from M@P service
			this.mapJson = null;

			/**
			 * Holds qtip options. See http://craigsworks.com/projects/qtip2/docs/
			 *
			 * @property qtipConfig
			 * @type {{position: {my: string, at: string, viewport: (*|HTMLElement), adjust: {x: number, y: number}},
			 *		hide: {fixed: boolean}, content: {title: boolean, text: Function}, show: {event: string}, style: {classes: string}}}
			 */
			this.qtipConfig = QTIP_CONFIG; // Moved this out of init, to the bottom of this file. Not 100% about this convention, but at least it now only gets processed once.

			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			mod.$ctx.on('randomFormToken', $.proxy(this.onRandomFormToken, this));
			mod.isMobile = SCS.utils.isMobilePage();

			this.formTag = this.$ctx[0].tagName === 'FORM' ? this.$ctx : $('form', this.$ctx);

			mod.initApi();

			// Only execute custom styles on desktop because jquery ui runs on mobile
			if (!SCS.utils.isMobilePage()) {
				mod.$ctx.find('select.customDropDown').sSelect();
			}

			mod.placeholdersData = {
				'ecVisitorId': typeof visitor === 'object' ? visitor.getMarketingCloudVisitorID() : ''
			};

			// 1. Set global properties
			mod.$form = mod.$ctx.find('form:first');
			mod.$stageMobile = mod.$ctx.closest('div.stageMobile');
			mod.formIdEl = mod.$ctx.find(mod.formIdSelector);
			mod.formId = (typeof mod.formIdEl != 'undefined' && mod.formIdEl.length) ? mod.formIdEl.val() : '';
			mod.formStartEl = mod.$ctx.find(mod.formStartSelector);
			mod.formStart = (typeof mod.formStartEl != 'undefined' && mod.formStartEl.length) ? mod.formStartEl.val() : '';

			// 2. Bind events
			mod.$form.on('submit', $.proxy(mod.formSubmitHandler, mod));

			mod.$ctx.on('formerror', $.proxy(mod.formErrorHandler, mod));

			mod.$ctx.one('formFieldsChanged', $.proxy(mod.prefillFormData, mod));

			mod.$ctx.on('change', mod.radioSelector, $.proxy(mod.radioSelectHandler, mod));

			// Need this for validation of radio groups
			mod.$ctx.on('valuechange', mod.radioGroupSelector, function (event, el) {
				var $group = $(el).closest(mod.radioGroupSelector),
					selected = $group.find('input:radio:checked').length;

				$group.data('selected', selected);
			});

			// Does not work on click in webkit
			mod.$ctx.on('focus', mod.radioSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').addClass('focus');
			});

			// Does not work when clicking away in webkit
			mod.$ctx.on('blur', mod.radioSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').removeClass('focus');
			});

			// Does not work on click in webkit
			mod.$ctx.on('focus', mod.checkboxSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').addClass('focus');
			});

			// Does not work when clicking away in webkit
			mod.$ctx.on('blur', mod.checkboxSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').removeClass('focus');
			});

			mod.$ctx.on('change', mod.selectSelector, $.proxy(mod.selectChangeHandler, mod));

			mod.$ctx.on('change', mod.checkboxSelector, $.proxy(mod.checkboxClickHandler, mod));

			// Need this for validation of checkbox groups
			mod.$ctx.on('valuechange', mod.checkboxGroupSelector, function (event, el) {
				var $group = $(el).closest(mod.checkboxGroupSelector),
					selected = $group.find('input:checkbox:checked').length;
				$group.data('selected', selected);
			});

			mod.$ctx.on('click', mod.saveButtonSelector, $.proxy(mod.clickSaveHandler, mod));
			mod.$ctx.on('click', mod.cancelButtonSelector, $.proxy(mod.clickCancelHandler, mod));
			mod.$ctx.on('click', mod.forwardButtonSelector, $.proxy(mod.clickForwardHandler, mod));

			$('.scs-form-summary a[href*="${"]', mod.$ctx).each(function () {
				var href = $(this).attr('href');
				href = href.replace(/\${/g, '__FIELDNAME__');
				href = href.replace(/}/g, '__');
				$(this).attr('data-url-with-placeholder', href);
			});

			mod.$ctx.on('click', 'a[data-url-with-placeholder]', $.proxy(mod.clickLinkWithPlaceholder, mod));

			// 3. Preparation
			mod.initForm();

			// 4. Get data from M@P for logged-in user (if any)
			if (mod.formApi.loadsMapData()) {
				mod.getDataFromMap(mod.$ctx.data('map-url'));
			}

			var numberOfPixelsToMoveFocus = mod.$ctx.data('number-of-pixels-to-move-focus');
			if (numberOfPixelsToMoveFocus) {
				mod.scrollToForm(numberOfPixelsToMoveFocus, 2000);
				// Due to lazy loading of images on publish instances, we need second call to recalculate positions
				setTimeout(function () {
					mod.scrollToForm(numberOfPixelsToMoveFocus, 500);
				}, 2500);
			}

			callback();
		},

		scrollToForm: function (numberOfPixelsToMoveFocus, scrollTime) {
			var mod = this;
			if (mod.$ctx.find('.headingError.server-side').length) {
				$('html, body').stop(true, true).animate({
					scrollTop: mod.$ctx.find('.headingError.server-side').offset().top + numberOfPixelsToMoveFocus
				}, scrollTime);
			} else if (!mod.$ctx.children('form').length) {
				$('html, body').stop(true, true).animate({
					scrollTop: mod.$ctx.offset().top + numberOfPixelsToMoveFocus
				}, scrollTime);
			}
		},

		//Fill mapJson and call callback function
		getDataFromMap: function (mapUrl) {
			var mod = this;
			require('lib/personalization/profile')
				.getProfile()
				.then(function (profile) {
					if (!!profile.getUser()) {
						mod.mapDataCall = $.ajax({
							url: mapUrl,
							type: 'get',
							dataType: 'json'
						});
						return mod.mapDataCall;
					} else {
						return Promise.reject();
					}
				})
				.then(function (json) {
					mod.mapDataCall = null;
					if (json) {
						mod.mapJson = {};
						for (var key in json) {
							if (json.hasOwnProperty(key)) {
								mod.mapJson[mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX + key] = json[key];
							}
						}
						mod.setPrefillFormDataFromMap();
					}
				})
				.catch(function (err) {
					if (err) {
						mod.mapDataCall = null;
						debug.log('get M@P data failed', err.responseText);
					}
					mod.$ctx.trigger('MapDataPrefilFailed');
				});
		},

		onRandomFormToken: function (event, data) {
			var mod = this;
			if (data && data.action === 'generate' && !this.randomFormTokenInProgress) {
				this.randomFormTokenInProgress = true;
				if (!this.randomFormToken) {
					this.randomFormToken = Math.round(Math.random() * 100000) + '' + new Date().getTime();
					this.setFieldValue('randomToken', this.randomFormToken, true);
				}
				data.cb({action: 'set', token: mod.randomFormToken});
				this.randomFormTokenInProgress = false;
			}
		},

		initApi: function () {
			var mod = this;

			mod.formApi = {

				/**
				 * Use for reinitializing the form. Elements that have already been initialized will be ignored.
				 */
				reInit: function () {
					mod.initForm();
					mod.prefillFormData();
				},

				/**
				 * Returns true the number of invalid fields is greater than 0, without showing the errors on the form
				 * @returns {boolean}
				 */
				isFormValid: function () {
					mod.resetInvalidFields();
					return mod.checkFieldValidation() === 0;
				},

				/**
				 * Sets everything back to 0 and removes all errors
				 */
				resetValidation: function () {
					mod.resetFormValidation();
				},

				resetValidationContext: function () {
					delete mod.$validationContext;
				},

				/**
				 * Set a context to only validate a part of a form
				 * @param $validationContext
				 */
				setValidationContext: function ($validationContext) {
					mod.$validationContext = $validationContext;
				},

				/**
				 * Checks form validation, marks errors and returns the number of invalid fields
				 * @returns {Number}
				 */
				validateForm: function (context) {
					mod.resetFormValidation();

					var invalidFields = mod.checkFieldValidation(context);

					if (invalidFields > 0) {
						mod.$ctx.trigger('formerror');
					}

					this.resetValidationContext();


					return invalidFields;
				},

				updateSummaries: function () {
					mod.updateSummaries();
				},

				executeSpecialButtonHandlers: function (execute) {
					mod.executeSpecialButtonHandlers = execute;
				},

				getReferrerButton: function () {
					return mod.getReferrerButton();
				},

				submit: function () {
					mod.$form.submit();
				},

				setEnableValidationScrolling: function (enableValidationScrolling) {
					mod.enableValidationScrolling = enableValidationScrolling;
				},

				renderPopupMessage: function (errorMessage, errorTitle) {
					if (!SCS.utils.isMobilePage()) {
						$('<div/>').attr('title', errorTitle || "").text(errorMessage).dialog();
					} else {
						var $popupMessage = $('<div id="ajaxErrorPopup" data-role="popup"></div>').append((errorTitle ? ('<h3>' + errorTitle + '</h3>') : '') + '<p>' + errorMessage + '</p>');
						$popupMessage.appendTo('body');
						$popupMessage.popup().popup('open');
						$popupMessage.on('popupafterclose', function () {
							$popupMessage.popup('destroy');
							$popupMessage.remove();
						});
					}
				},

				loadsMapData: function () {
					return mod.$ctx.data('enable-map') &&
						mod.$ctx.data('map-url') &&
						mod.mapDataCall !== 'cancelled';
				},

				cancelMapDataCall: function () {
					if (mod.mapDataCall && mod.mapDataCall.abort) {
						mod.mapDataCall.abort();
					}
					mod.mapDataCall = 'cancelled';
				},

				onFormValidate: function (callback) {
					mod.resetFormValidation();

					var invalidFields = mod.checkFieldValidation(callback);

					if (invalidFields > 0) {
						mod.$ctx.trigger('formerror');
					} else {
						callback();
					}
				}
			};

			// Module API
			mod.$ctx.data('form-api', mod.formApi);
			// Alias as plain 'api' for backwards-compatibility
			mod.$ctx.data('api', mod.formApi);
		},

		initForm: function () {
			var mod = this;
			mod.prefillData = undefined;
			mod.setupInputs();
			mod.setUpCheckboxes();
			mod.setupCheckboxGroups();
			mod.setUpRadios();
			mod.setupRadioGroups();
			mod.setUpSelects();
			mod.setupToolTip();
			mod.initSummary();
			mod.initPlaceholderFields();

			mod.setUpRadiosInitIE();
		},

		initPlaceholderFields: function () {
			var mod = this,
				$ctx = mod.$ctx;

			$('[type="hidden"]', $ctx).each(function () {
				var $input = $(this),
					placeholderValue = $input.data('placeholder-value') || '';

				if (placeholderValue) {
					var value = replacePlaceholders(placeholderValue, mod.placeholdersData);
					if (value) {
						$input.val(value);
					}
				}
			});
		},

		autoSubmit: function () {
			var mod = this,
				$ctx = mod.$ctx;

			if ($ctx.data('auto-submit')) {
				// Check field validation requirements
				var numberOfInvalidFields = mod.checkFieldValidation('submit');
				if (numberOfInvalidFields > 0) {
					mod.$ctx.trigger('formerror');
					mod.$form.removeClass('hidden');
					$ctx.find('.loader').addClass('hidden');
				} else {
					// Submit form
					$.ajax({
						type: "POST",
						url: $ctx.find('form').attr('action'),
						data: $ctx.find('form').serialize() + '&auto-submit=true',
						dataType: 'html',
						success: function (response) {
							if (response && response.length) {
								$ctx.replaceWith(response);
							}
						},
						error: function () {
							debug.log("Tc.Module.ScForm > auto submit action failed, POST request error");
							mod.$form.removeClass('hidden');
							$ctx.find('.loader').addClass('hidden');
						}
					});
				}
			}
		},

		after: function () {
			var mod = this,
				$ctx = mod.$ctx,
				prefillUrl = $ctx.data('prefill-url');

			this.prefillFormData();

			if (mod.$ctx.data('formSynchronization')) {
				var groupId = mod.$ctx.data('formSynchronizationId');
				// get a list of all synchronized forms and cache the result (only query once)
				if (typeof synchronizedForms === 'undefined' || !synchronizedForms) {
					synchronizedForms = $('.modScForm[data-form-synchronization="true"]');
				}
				// collect the group members of this synchronized forms group (only query once)
				if (typeof synchronizedGroups[groupId] === 'undefined' || !synchronizedGroups[groupId]) {
					var groupFilter = function () {
						return $(this).data('formSynchronizationId') === groupId;
					};
					synchronizedGroups[groupId] = synchronizedForms.filter(groupFilter);
				}
				// change event still needed here for ie. radio buttons and other "unaware" components
				mod.$ctx.on('change', mod.allInputFieldsSelector, $.proxy(mod.synchValueChangedHandler, mod));
			}

			if (!prefillUrl) {
				mod.autoSubmit();
			}
		},

		doExecuteSpecialButtonHandlers: function () {
			return this.executeSpecialButtonHandlers === undefined || this.executeSpecialButtonHandlers;
		},

		/**
		 * Returns collection of input field with html attribute "data-clientvalidation"
		 *
		 * @returns {*|HTMLElement}
		 */
		getFieldsWithValidation: function () {
			var mod = this,
				$ctx = this.$ctx;

			if (mod.$validationContext && mod.$validationContext.length > 0) {
				$ctx = mod.$validationContext;
			}

			return $ctx.find('.field[data-clientvalidation]').filter(function () {
				return !$(this).data('do-not-validate');
			});

		},

		setUpCheckboxes: function () {
			var mod = this;
			mod.$ctx.find('.custom-checkbox input:checkbox').each($.proxy(mod.setCustomInputCheckbox, mod));
		},

		setupInputs: function () {
			this.$ctx.find('input, textarea').placeholder();
		},

		setUpRadios: function () {
			var mod = this;
			mod.$ctx.find('.custom-radio input:radio').each($.proxy(mod.setCustomInputRadio, mod));
		},
		setUpRadiosInitIE: function () {
			// check if ie
			if (window.navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
				var mod = this;
				mod.$ctx.find('.custom-radio input:radio').each($.proxy(mod.setCustomInputRadioInitIE, mod));
			}
		},

		setUpSelects: function () {
			var mod = this;
			mod.$ctx.find('.modSelectbox select').each($.proxy(mod.setCustomSelect, mod));
		},

		setUpFieldsWithValidation: function () {
			var mod = this;

			mod.getFieldsWithValidation().each(function () {
				var $this = $(this);

				// Create new instance of ClientValidation for easier handling and store as data on element
				$this.data('clientvalidationInstance', ScForm.createClientValidation($this.data('clientvalidation'), mod.$ctx));
			});
		},

		/**
		 * Takes the name of an input:radio group and sets their custom styles according to the input select state.
		 *
		 * @method setInputRadioByName
		 * @param {String} name
		 */
		setInputRadioByName: function (name) {
			var mod = this;

			mod.$ctx.find('input:radio[name="' + name + '"]').each($.proxy(mod.setCustomInputRadio, mod));

			return mod;
		},

		/**
		 * This function is called on init and every time a radio is selected
		 *
		 * @method setCustomInputRadio
		 * @param {Number} index (optional)
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomInputRadio: function (index, domElem) {
			var mod = this,
				$radio = $(domElem);

			if ($radio.is(':radio')) {
				$radio.parent()
					.find('label[for="' + $radio.attr('id') + '"]')
					.toggleClass('checked', $radio[0].checked);
				this.setCustomInputSelectionHiddenLabel($radio);
			}
			return mod;
		},

		/**
		 * This function is called on init
		 *
		 * @method setCustomInputRadio
		 * @param {Number} index (optional)
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomInputRadioInitIE: function (index, domElem) {
			var mod = this,
				$radio = $(domElem);

			if ($radio.is(':radio')) {
				var labelTag = $radio.parent().find('label[for="' + $radio.attr('id') + '"]');

				// Quickfix for IE that messes up clickable elements/the render tree when loaded..
				// touching DOM elements helps..
				setTimeout(function () {
					labelTag.css("display", "inline");
					setTimeout(function () {
						labelTag.css("display", "");
					}, 1);
				}, 2);

			}
			return mod;
		},


		/**
		 * This function is called on init and every time a select is selected
		 *
		 * @method setCustomInputSelect
		 * @param {Number} index (optional)
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomSelect: function (index, domElem) {
			var mod = this,
				$select = $(domElem);

			if ($select[0].tagName === 'SELECT') {
				this.setCustomInputSelectionHiddenLabel($select);
			}
			return mod;
		},

		/**
		 * @method setCustomInputCheckbox
		 * @param {Number} index
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomInputCheckbox: function (index, domElem) {
			var mod = this,
				$chkbox = $(domElem),
				isChecked = domElem.checked;

			if ($chkbox.is(':checkbox')) {
				$chkbox.parent()
					.find('label[for="' + $chkbox.attr('id') + '"]')
					.toggleClass('checked', isChecked)
					.find('span.checkbox-control')
					.attr('aria-checked', isChecked);
				this.setCustomInputSelectionHiddenLabel($chkbox);
			}

			return mod;
		},

		setCustomInputSelectionHiddenLabel: function (field) {
			var hiddenLabel = field.data('hiddenLabel'),
				hiddenLabelName = field.attr('name') + '_label',
				hiddenLabelId = field.attr('id') + '_label';
			if (!hiddenLabel) {
				hiddenLabel = $('input[name="' + hiddenLabelName + '"][data-id="' + hiddenLabelId + '"]', field.parent());
				if (hiddenLabel.length === 0) {
					hiddenLabel = $('<input type="hidden" name="' + hiddenLabelName + '" data-id="' + hiddenLabelId + '" data-validate="false" />');
					field.parent().append(hiddenLabel);
				}
				field.data('hiddenLabel', hiddenLabel);
			}

			if (field.is(':radio') || field.is(':checkbox')) {
				if (field[0].checked) {
					var labelTag = field.parent().find('label[for="' + field.attr('id') + '"]');
					var labelTagItemTitle = labelTag.find('.item-title');
					if (labelTagItemTitle.length > 0) {
						labelTag = labelTagItemTitle;
					}
					hiddenLabel.prop('disabled', false).val($.trim(labelTag.text())).trigger('change');
				} else {
					hiddenLabel.prop('disabled', true).val('').trigger('change');
				}
			}

			if (field[0].tagName === 'SELECT') {
				hiddenLabel.val($.trim(field.find('option:selected').text())).trigger('change');
			}
		},

		/**
		 * Event handler
		 * @method selectChangeHandler
		 * @param event
		 */
		selectChangeHandler: function (event) {
			var mod = this,
				el = event.currentTarget;

			mod.setCustomSelect(0, el);

			//set hasChanged for M@P prefill
			$(el).data('hasChanged', true);


			if (mod.isMobile) {
				$(el).trigger('valuechange', [el]);
			}

			return mod;
		},

		/**
		 * Event handler
		 * @method checkboxClickHandler
		 * @param event
		 */
		checkboxClickHandler: function (event) {
			var mod = this,
				el = event.currentTarget;
			if ($(el).is('[readonly]')) return mod;

			mod.setCustomInputCheckbox(0, el);

			if (mod.isMobile) {
				$(el).closest(mod.checkboxGroupSelector).trigger('valuechange', [el]);
			}

			return mod;
		},

		formErrorHandler: function () {
			var mod = this, i, ii;

			// 1. Marks all fields that are invalid
			for (i = 0, ii = mod.invalidFields.length; i < ii; i += 1) {
				mod.markFieldAsInvalid(mod.invalidFields[i]);
			}

			// 2. Display error messages
			mod.updateClientErrorView(mod.invalidFields);

			return mod;
		},

		formSubmitHandler: function (event) {
			var mod = this,
				numberOfInvalidFields,
				$formButton = mod.$ctx.find('button[type=submit]');

			var successTracking = mod.$ctx.data('successtracking-enabled');
			var warehouseTracking = mod.$ctx.data('datawarehouse-tracking-enabled');

			// previous form submit was delayed for tracking
			// after a short delay we trigger a submit again
			// checks have been done before, just do the submit
			if (mod.formSubmitDelayed) return true;

			try {
				$formButton.addClass('is-hidden');
				// Reset previous validation
				mod.resetFormValidation();

				// Check field validation requirements
				numberOfInvalidFields = mod.checkFieldValidation('submit');

				if (numberOfInvalidFields > 0) {
					mod.$ctx.trigger('formerror');

				} else {
					var allSummariesConfirmed = true,
						summaries = mod.getSummaries();

					for (var i = 0; i < summaries.length; i += 1) {
						var summary = summaries[i];
						if (!summary.el.data('confirmed')) {
							if (event) {
								event.preventDefault();
							}
							if (summary.el.find('.scs-form-navigation').length > 0) {
								mod.$stageMobile.addClass('navigation-back');
							}
							mod.showSummary(summary, true);
							window.scrollTo(0, 0);
							allSummariesConfirmed = false;
						}
					}

					if (allSummariesConfirmed) {
						if (successTracking || warehouseTracking) {
							mod.formSuccessTracking();
							mod.dataWarehouseTracking();
							// delay submit to allow tracking
							event.preventDefault();
							mod.formSubmitDelayed = true;
							// trigger real submit a bit later
							setTimeout(function () {
								mod.$form.trigger('submit');
								mod.formSubmitDelayed = false;
							}, 50);

							// Prevent premature submission
							return false;
						}
						// Return early to submit the form
						return true;
					}
				}
			} catch (e) {
				$formButton.removeClass('is-hidden');

				debug.log('Tc.Module.ScForm: JS exception when trying to submit form', e);
				if (event) {
					// The form must not submit data before validation in case there is a javascript exception
					event.preventDefault();
					throw e;
				}
			}

			$formButton.removeClass('is-hidden');
			return false;
		},

		/**
		 * Triggers the Swisscom form submit tracking for tealium
		 */
		formSuccessTracking: function () {
			var mod = this,
				$ctx = mod.$ctx,
				conversionCategory = $ctx.data('conversion-category'),
				conversionDetail = $ctx.data('conversion-detail'),
				conversionClass = $ctx.data('conversion-class'),
				eventAction = $ctx.data('track-action'),
				eventLocation = $ctx.data('track-location'),
				eventLabel = $ctx.data('track-label'),
				eventCategory = $ctx.data('track-category');

			debug.log('Tc.Module.ScForm > formSuccessTracking > triggering conversion:', conversionCategory, conversionDetail, conversionClass);

			new SCS.portal.datalayer.Interaction()
				.withEvent(eventAction, eventLabel, eventLocation, eventCategory, "")
				.withConversion(conversionCategory, conversionDetail, conversionClass)
				.track();
		},

		/**
		 * Triggers the Swisscom datawarehouse tracking
		 */
		dataWarehouseTracking: function () {
			var mod = this,
				$ctx = mod.$ctx,
				/* jshint camelcase: false */
				location = window.utag_data && window.utag_data.page_template && window.utag_data.page_template !== mod.TEMPLATE_TYPE_HELP_WIDGET ? 'Content' : 'Help-Widget',
				interaction = new SCS.portal.datalayer.Interaction()
					.withEvent('submit', '', location, 'form');

			if ($ctx.data('datawarehouse-tracking-enabled')) {
				debug.log("Tc.Module.ScForm.js > dataWarehouseTracking > enabled");
				interaction.event.rawdata = {};

				$ctx.find('[data-sdw-mapping]').each(function () {
					// skip unselected radio buttons and checkboxes
					if (($(this).is('input:radio') || $(this).is('input:checkbox')) && !$(this).is(':checked')) {
						return true;
					}
					interaction.event.rawdata[$(this).data('sdw-mapping')] = $(this).val();
					debug.log('Tc.Module.ScForm > ' + $(this).data('sdw-mapping') + ' > ' + $(this).val());
				});

				interaction.track();
			}
		},

		radioSelectHandler: function (event) {
			var mod = this,
				el = event.currentTarget,
				$radio = $(el);

			if ($radio.is('[readonly]')) return mod;

			mod.setInputRadioByName($radio.attr('name'));

			if (mod.isMobile) {
				$(el).closest(mod.radioGroupSelector).trigger('valuechange', [el]);
			}
			return mod;
		},

		/**
		 * @method checkFieldValidation
		 * @returns {Number}
		 */
		checkFieldValidation: function (context) {
			var mod = this;
			// setup the validation object when the form fields are evaluated
			mod.setUpFieldsWithValidation();
			mod.getFieldsWithValidation().each(function (index) {
				var $this = $(this),
					$inputs = $this.find('input[data-validate!="false"],textarea[data-validate!="false"],select[data-validate!="false"],sdx-input-group[data-validate!="false"]').filter(function () {
						return ($(this).attr('name') !== 'recaptcha_challenge_field');
					}),
					cv, vr,
					inputType = [$inputs.attr('type')],
					inputValue = [$.trim($inputs.val())],
					i, x;

				cv = $this.data('clientvalidationInstance');
				if ($this.data('is-multifield') === true) {
					inputValue = [];
					inputType = [];
					for (i = 0; i < $inputs.length; i += 1) {
						var field = $($inputs[i]);
						inputValue.push(field.val());
						inputType.push(field.attr('type'));
					}
				}

				for (x = 0; x < inputValue.length; x += 1) {
					if((inputType[x] === 'radio' || inputType[x] === 'checkbox') && $inputs[x].tagName.toLowerCase() === 'sdx-input-group') {
						vr = cv.validateSDXInputGroup($inputs[x].value);
					} else if (inputType[x] === 'radio') {
						vr = cv.validateRadioGroup($this.find('input:radio:checked').length, context);
					} else if (inputType[x] === 'checkbox') {
						vr = cv.validateCheckboxGroup($this.find('input:checkbox:checked').length, context);
					} else {
						vr = cv.validate(inputValue[x], context);
					}

					if (vr.isValid === false) {
						if (mod.invalidFields.length === 0) {
							if (mod.enableValidationScrolling) {
								mod.scrollToElement($this);
							}
						}
						mod.invalidFields.push(ScForm.createInvalidField(index, vr).setField($($inputs[x])));
					}
				}
			});

			return mod.invalidFields.length;
		},

		scrollToElement: function (element) {
			var scrollOffset = element.offset().top,
				windowScrollOffset = $(window).scrollTop(),
				windowHeight = $(window).height();
			if (scrollOffset < windowScrollOffset || scrollOffset + 40 > windowScrollOffset + windowHeight) {
				$('html, body').animate({scrollTop: (scrollOffset - 20)}, 1000);
			}
		},

		/**
		 * Marks the invalid fields with a css class
		 *
		 * @method markFieldAsInvalid
		 * @param {InvalidField} invalidField
		 * @returns {Tc.Module.ScForm}
		 */
		markFieldAsInvalid: function (invalidField) {
			var mod = this,
				$field = mod.getFieldsWithValidation().eq(invalidField.getIndex()),
				$errorField = $field.find('span.error');
			if ($field.closest('.sdx-container').length) {
				$field.find('.sdx.message').removeClass('hidden');
			}

			$field.addClass('error');
			$errorField.html($errorField.html() + ($errorField.html() === '' ? '' : '<br/>') + $('<div>').text(invalidField.getVr().getMessage() || '').html());
			$errorField.removeClass('hidden');
			invalidField.getField().addClass('error-field');
			return mod;
		},

		/**
		 * Removes all error markings from form
		 *
		 * @method resetFormValidation
		 * @returns {Tc.Module.ScForm}
		 */
		resetFormValidation: function () {
			var mod = this,
				$ctx = mod.$ctx;

			mod.resetInvalidFields();
			$('div.headingError', $ctx).addClass('hidden');
			if (mod.$validationContext && mod.$validationContext.length > 0) {
				$ctx = mod.$validationContext;
			}
			$('.sdx.message', $ctx).addClass('hidden');
			$('div.error, fieldset.error', $ctx).removeClass('error');
			$('.error-field', $ctx).removeClass('error-field');
			$('span.error', $ctx).addClass('hidden').text('');

			return mod;
		},

		/**
		 * Resets array containing list of all fields that are marked as invalid
		 *
		 * @method resetInvalidFields
		 * @returns void
		 */
		resetInvalidFields: function () {
			this.invalidFields = [];
		},

		/**
		 * Inserts error messages into dom and shows them
		 *
		 * @method updateClientErrorView
		 * @param invalidFields {Array<InvalidField>}
		 * @returns {Tc.Module.ScForm}
		 */
		updateClientErrorView: function (invalidFields) {
			var mod = this,
				// $clientErrorView = $('div.headingError', mod.$ctx);
				$clientErrorView = $('div.headingError:not(.server-side)', mod.$ctx);

			// Only show message if there are errors and a message text is specified
			if (invalidFields.length > 0 && $.trim($clientErrorView.find('span.msg').text()) !== '') {
				$clientErrorView.removeClass('hidden');
			}

			return mod;
		},

		/**
		 * Creates instance of qtip for hints. Checks if qtip instance is available.
		 *
		 * @method setupToolTip
		 * @return {Tc.Module.ScForm}
		 */
		setupToolTip: function () {
			var mod = this,
				$buttonFieldHints = mod.$ctx.find('button.field-hint'),
				i = 0,
				ii = $buttonFieldHints.length;

			for (; i < ii; i += 1) {
				mod.createQtipInstance($buttonFieldHints.eq(i), mod.qtipConfig);
			}

			return mod;
		},

		/**
		 * Create qTip instance on element such as <button class="field-hint" data-hint="Foo"></button>
		 *
		 * @param $buttonFieldHint
		 * @param qTipConfig
		 */
		createQtipInstance: function ($buttonFieldHint, qTipConfig) {
			if ($buttonFieldHint.length !== 1 || typeof ($buttonFieldHint.data('hint')) === 'undefined') {
				throw ('Trying to create qtip instance on element without hint');
			}

			if (typeof ($buttonFieldHint.data('qtip')) === 'undefined') {
				debug.log('Tc.Module.ScForm > initialized Tooltip');
				$buttonFieldHint.qtip(qTipConfig);
			}
		},

		/**
		 * Initializes checkbox groups. Every checkbox group has a minimum of one checkbox, hence every checkbox is a group. Checkbox groups have a wrapper with the role="group"
		 *
		 * @method setupCheckboxGroups
		 * @return {number}
		 */
		setupCheckboxGroups: function () {
			var mod = this,
				initCounter = 0;

			mod.$ctx.find(mod.checkboxGroupSelector).each(function () {
				var $group = $(this);

				if ($group.data('init') !== true) {
					$group.data('selected', $group.find('input:checkbox:checked').length);
					$group.attr('data-init', true);
					initCounter += 1;
				}
			});

			debug.log('Tc.Module.ScForm > initialized Checkbox Groups: ' + initCounter);
			return initCounter;
		},

		/**
		 * Initializes radio groups
		 *
		 * @method setupRadioGroups
		 * @returns {number}
		 */
		setupRadioGroups: function () {
			var mod = this,
				initCounter = 0;

			mod.$ctx.find(mod.radioGroupSelector).each(function () {
				var $group = $(this);

				if ($group.data('init') !== true) {
					$group.data('selected', $group.find('input:radio:checked').length);
					$group.attr('data-init', true);
					initCounter += 1;
				}
			});

			debug.log('Tc.Module.ScForm > initialized Radio Groups: ' + initCounter);
			return initCounter;
		},

		/**
		 * Returns a map of fields and their visible values, meaning
		 * that for select boxes, radio buttons and checkboxes it will
		 * take the labels, for all other fields their actual values.
		 * If the field has more than one value, the value for this field
		 * will be an array of values.
		 */
		getFieldsAsMapForSummary: function () {
			var fieldMap = {},
				mod = this;
			//we ignore the _label fields as they do not contain user inputs
			mod.$form.find(':input:not([name$=_label])').each(function () {
				var elem = $(this),
					value = $(this).val(),
					type = 'text',
					data = value,
					found = true,
					label;
				if (this.type === 'checkbox') {
					type = this.type;
					found = false;
					value = [];
					mod.$form.find('input[name="' + this.name + '"]').each(function () {
						var checkbox = $(this);
						if (checkbox.is(':checked')) {
							label = checkbox.next('label[for="' + checkbox.attr('id') + '"]');
							if (label) {
								value.push($.trim(label.text()));
							}
						}
					});
					if (value.length > 0) {
						found = true;
						data = value;
					}
				} else if (this.type === 'radio') {
					type = this.type;
					found = false;
					if (elem.is(':checked')) {
						label = elem.next('label[for="' + elem.attr('id') + '"]');
						if (label) {
							value = $.trim(label.text());
							data = value;
							found = true;
						}
					}
				} else if (elem.is('SELECT')) {
					type = 'select';
					found = false;
					elem.children().each(function () {
						var option = $(this);
						if (option.attr('value') === elem.val()) {
							if (value === '' || value === -1) {
								value = '';
							} else {
								value = option.text();
							}
							data = value;
							found = true;
						}
					});
				} else if (elem.data('type') === 'file') {
					type = 'file';
					found = false;
					value = [];
					data = [];
					mod.$form.find('input[name="' + this.name + '"]').each(function () {
						var $this = $(this),
							link = $this.siblings('.fileDescription').clone();
						value.push($('<div>').append(link).html());
						data.push({
							text: link.find('.text').text(),
							size: link.find('.size').text(),
							uuid: $this.val()
						});
					});
					if (value.length > 0) {
						found = true;
						value = '<span class="fileList">' + value.join('') + '</span>';
					}
				} else if (this.type === 'text') {
					value = [];
					mod.$form.find('input[name="' + this.name + '"]').each(function () {
						var fieldValue = $(this).val();
						if (fieldValue) {
							value.push(fieldValue);
						}
					});
					if (value.length > 0) {
						data = value;
					}
				}

				if (found && fieldMap[this.name] === undefined) {
					fieldMap[this.name] = {
						type: type,
						data: data,
						value: value
					};
				}
			});
			return fieldMap;
		},

		clickSaveHandler: function (event) {
			event.preventDefault();
			this.updateSummaries();
			var mod = this,
				formStartParameterName = ':formstart',
				frm = mod.formTag,
				formStartParameter = $('input[name="' + formStartParameterName + '"]', frm),
				serializedData;
			formStartParameter.attr('name', 'formstart');
			try {
				serializedData = frm.serialize();
			} finally {
				formStartParameter.attr('name', formStartParameterName);
			}
			$.ajax({
				type: 'POST',
				url: frm.attr('action').replace('.html', '.formarchive.save.json'),
				dataType: 'json',
				data: serializedData,
				success: function (data) {
					if (data.success === 'true' || data.success === true) {
						if (data.entryId) {
							mod.setFieldValue(':archiveId', data.entryId, true);
						}
						if (data.lastUpdated) {
							mod.setLastSavedDate(data.lastUpdated);
						}
					}
					// TODO: display 'could not save' message otherwise?
				},
				error: function () {
					mod.showDialog('Error', mod.$ctx.data('error-msg'));
				}
			});
		},

		setLastSavedDate: function (date) {
			if (!this.lastSavedDateContainer) {
				this.lastSavedDateContainer = $('<p/>').addClass('sentdate');
				this.formTag.prepend(this.lastSavedDateContainer);
			}
			this.lastSavedDateContainer.text(this.$ctx.data('txt-last-saved') + ' ' + date);
			this.lastSavedDateContainer.show();
		},

		showDialog: function (title, text) {
			$('<div/>').attr('title', title).append(text).dialog();
		},

		clickCancelHandler: function (event) {
			var $el = $(event.currentTarget);
			window.location.href = $el.attr('href');
			event.preventDefault();
		},

		clickForwardHandler: function (event) {
			var mod = this;
			if ($('body').hasClass('cq_isEditMode')) {
				event.preventDefault();
				mod.showDialog('Forms in multi-page steps cannot be submitted individually.', mod.$ctx.data('error-msg'));
			} else if (this.doExecuteSpecialButtonHandlers()) {
				this.clickSummaryActionHandler(event);
			}
		},

		clickLinkWithPlaceholder: function (event) {
			event.preventDefault();
			var mod = this,
				key,
				$el = $(event.currentTarget),
				href = $el.attr('data-url-with-placeholder'),
				target = $el.attr('target') ? $el.attr('target') : '_self';

			// Reset previous validation
			mod.resetFormValidation();

			// Check field validation requirements
			var numberOfInvalidFields = mod.checkFieldValidation();

			if (numberOfInvalidFields > 0) {
				mod.$ctx.trigger('formerror');
			} else {
				var fieldMap = mod.getFieldsAsMapForSummary();
				for (key in fieldMap) {
					if (fieldMap.hasOwnProperty(key)) {
						var value = encodeURIComponent(fieldMap[key].value);
						href = SCS.portal.replaceAll(href, '__FIELDNAME__' + key + '__', value);
					}
				}

				if (target === '_self') {
					location.href = href;
				} else {
					window.open(href, target);
				}
			}
		},

		// triggered on change for all fields in form
		synchValueChangedHandler: function (event) {
			var mod = this,
				index = this.$ctx.find(this.allInputFieldsSelector).index(event.target),
				originalField = $(event.target),
				field = null,
				value = originalField.val(),
				checked = originalField.prop('checked');

			// only sync on real user events
			// avoids endless sync loop
			if (event.originalEvent) {
				var groupId = mod.$ctx.data('formSynchronizationId') || '';
				$(synchronizedGroups[groupId]).not(mod.$ctx).each(function () {
					field = $(this).find(mod.allInputFieldsSelector).eq(index);
					if (field.length > 0) {
						var label = field.closest('.field').find('label');
						switch (event.target.type) {
							case 'radio':
								field.prop('checked', checked);
								$(field[0].form.elements[field[0].name]).each(function () {
									var el = $(this).closest('.field').find('LABEL')
										.filter('[for="' + $(this).prop('id') + '"]');
									el.toggleClass('checked', this.checked);
								});
								break;
							case 'checkbox':
								field.prop('checked', checked);
								label.toggleClass('checked', checked);
								break;
							default:
								field.val(value);
						}
						// for visibility containers
						field.trigger('sync-ui');
					}
				});

				// call sync-heights for accordions
				$(event.target).trigger('sync-heights');

			}
		},

		getReferrerButton: function (init) {
			if (!this.referrerButton && init) {
				this.referrerButton = $('<a/>').addClass('secondary-button').attr('href', document.referrer).text(this.$ctx.data('txt-back'));
			}
			return this.referrerButton;
		},

		initReferrerButton: function () {
			var button = this.getReferrerButton(true),
				submitButton = this.$ctx.find('button[type="submit"]');
			if (submitButton && submitButton.length > 0) {
				submitButton.parent().prepend(button);
			}
		},

		initSummary: function () {
			var summaries = this.getSummaries();
			for (var i = 0; i < summaries.length; i += 1) {
				summaries[i].el.on('click', '.multipage-back-button', $.proxy(this.clickSummaryBackwardHandler, this));
				summaries[i].el.on('click', '.multipage-action-button', $.proxy(this.clickSummaryActionHandler, this));
			}

			this.updateSummaries();
		},

		clickSummaryActionHandler: function (event) {
			var mod = this,
				i,
				summariesInForm;

			if (mod.doExecuteSpecialButtonHandlers()) {
				event.preventDefault();
				//check if its a single page form
				var $multipageStep = $(event.target).closest('.multipage-wizard-step');
				if ($multipageStep.length === 0) {
					summariesInForm = mod.getSummaries();
					for (i = 0; i < summariesInForm.length; i += 1) {
						summariesInForm[i].el.data('confirmed', true);
					}
				} else {
					//otherwise check that all summaries in this multipage step have been confirmed
					var $summariesOnStep = $multipageStep.find('.scs-form-summary');
					summariesInForm = mod.getSummaries();
					for (i = 0; i < summariesInForm.length; i += 1) {
						for (var j = 0; j < $summariesOnStep.length; j += 1) {
							var $summaryOnStep = $($summariesOnStep[j]);
							if (summariesInForm[i].el.is($summaryOnStep)) {
								summariesInForm[i].el.data('confirmed', true);
							}
						}
					}
				}
				this.$form.submit();
			}
		},

		clickSummaryBackwardHandler: function () {
			var mod = this;

			if (mod.doExecuteSpecialButtonHandlers()) {
				var summaries = this.getSummaries();
				for (var i = 0; i < summaries.length; i += 1) {
					mod.showSummary(summaries[i], false);
				}
				mod.$stageMobile.removeClass('navigation-back');
				if (mod.isMobile) {
					window.scrollTo(0, 0);
				}
			}
		},

		/**
		 * This functions returns the summary object for a form.
		 * Only one summary in a form is supported.
		 *
		 * @method getSummaries
		 */
		getSummaries: function () {
			return this.getSummariesForSelector(this.summarySelector);
		},

		getShortSummary: function () {
			if (!this.shortSummary) {
				this.shortSummary = this.getSummariesForSelector('.scs-form-short-summary');
			}
			return this.shortSummary;
		},

		getSummariesForSelector: function (selector) {
			var mod = this,
				$ctx = mod.$ctx,
				$summaries = $ctx.find(selector),
				$template,
				$content,
				response = [];

			var saveValue = function (name, value, parameter) {
				if (!this.savedValuesContainer) {
					this.savedValuesContainer = this.el.find('.savedValues');
					if (this.savedValuesContainer.length === 0) {
						this.savedValuesContainer = $('<div/>').addClass('savedValues').hide();
						this.el.append(this.savedValuesContainer);
					}
				}
				if (!parameter) {
					parameter = this.el.data('values-name');
				}

				// remove entry with same name from any summary
				$ctx.find('input[type=hidden]').filter(function () {
					return this.name === parameter && this.value.match('^' + name + '::');
				}).remove();

				// add entry
				var field = $('<input/>').attr('type', 'hidden').attr('name', parameter).val(name + '::' + value);
				this.savedValuesContainer.append(field);

				debug.log('Tc.Module.ScForm > saveValue', name + '::' + value);
			};

			if ($summaries.length > 0) {
				for (var i = 0; i < $summaries.length; i += 1) {
					var $summary = $($summaries[i]);
					$template = $('.scs-summary-template', $summary);
					$content = $('.scs-summary-content', $summary);
					response.push({
						el: $summary,
						content: $content,
						template: $template.html(),
						confirmed: false,
						saveValues: $summary.data('values-save') ? true : false, // seems to be always true
						saveValue: saveValue,
						saveAttachment: function (name, value) {
							this.saveValue(name, value, this.el.data('attachments-name'));
						},
						resetSavedValues: function () {
							if (this.savedValuesContainer && this.savedValuesContainer.length > 0) {
								this.savedValuesContainer.empty();
							}
						}
					});
				}
			}
			return response;
		},

		/**
		 * Updates one given summary with the newest form field
		 * values and sets the hidden summary parameter.
		 */
		updateSummaryHandler: function (summary, fieldMap) {
			if (summary && summary.template) {
				var mod = this,
					template = summary.template,
					key,
					value,
					container,
					$scssummary = [];

				if (summary.saveValues) {
					summary.resetSavedValues();
				}
				for (key in fieldMap) {
					if (fieldMap.hasOwnProperty(key)) {
						value = fieldMap[key].value;
						if ($.isArray(value)) {
							value = value.join(', ');
						}
						if (
							summary.saveValues &&
							(
								template.indexOf(mod.TPL_PREFIX + key + mod.TPL_SUFFIX) >= 0 ||
								template.indexOf(mod.TPL_ESCAPED_PREFIX + key + mod.TPL_ESCAPED_SUFFIX) >= 0
							)
						) {
							if (fieldMap[key].type === 'file') {
								if (fieldMap[key].data && fieldMap[key].data.length > 0) {
									var saveValue = [], i, dataEntry;
									for (i = 0; i < fieldMap[key].data.length; i += 1) {
										dataEntry = fieldMap[key].data[i];
										saveValue.push(dataEntry.uuid + ':' + dataEntry.text + ':' + dataEntry.size);
									}
									summary.saveAttachment(key, saveValue.join('|'));
								}
							} else {
								summary.saveValue(key, value);
							}
						}
						if (fieldMap[key].type !== 'file') {
							value = value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
						}
						// do replace only for textarea
						if (value && value.replace && fieldMap[key].type === 'textarea') {
							value = value.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
						}

						template = SCS.portal.replaceAll(template, mod.TPL_PREFIX + key + mod.TPL_SUFFIX, value);
						//the parameters that are used e.g. in URLS are escaped, hiding the ${...} placeholders
						template = SCS.portal.replaceAll(template, mod.TPL_ESCAPED_PREFIX + key + mod.TPL_ESCAPED_SUFFIX, value);
						//the summary displays the same information for ${field} and ${field_label}
						template = SCS.portal.replaceAll(template, mod.TPL_PREFIX + key + '_label' + mod.TPL_SUFFIX, value);
						template = SCS.portal.replaceAll(template, mod.TPL_ESCAPED_PREFIX + key + '_label' + mod.TPL_ESCAPED_SUFFIX, value);
					}
				}

				container = mod.$ctx.closest('.columncontainer');
				if (container.find('.mod').hasClass('modScForm')) {
					$scssummary = container.find('.scs-summary-field');
				} else {
					$scssummary = mod.$ctx.find('.scs-summary-field');
				}

				$scssummary.each(function () {
					var $this = $(this),
						name = $this.data('name');

					if (summary.saveValues && template.indexOf(mod.TPL_PREFIX + key + mod.TPL_SUFFIX) >= 0) {
						summary.saveValue(key, $this.text());
					}
					template = SCS.portal.replaceAll(template,
						mod.TPL_PREFIX + key + mod.TPL_SUFFIX, value.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
					template = SCS.portal.replaceAll(template,
						mod.TPL_PREFIX + name + mod.TPL_SUFFIX, $this.text());
				});

				// remove left over placeholders
				template = template.replace(/\${[a-zA-Z0-9_\/:\-]*}/g, '');

				template = $('<div>').append(template);
				template.find('*').addClass('ctHidden');

				// write back to the DOM
				summary.content[0].innerHTML = template[0].innerHTML; // does not execute scripts in content
			}
		},

		updateSummaries: function () {
			var fieldMap = this.getFieldsAsMapForSummary(),
				summaries = this.getSummaries();
			for (var i = 0; i < summaries.length; i += 1) {
				this.updateSummaryHandler(summaries[i], fieldMap);
			}

			this.updateSummaryHandler(this.getShortSummary(), fieldMap);

		},

		/**
		 * Depending on the given "show" parameter, either hides all
		 * form fields and shows the summary, or vice versa.
		 */
		showSummary: function (summary, show) {
			var mod = this,
				$ctx = mod.$ctx,
				$summary = summary.el,
				$container = $summary.closest('.parsys'),
				$colcontainer = $summary.closest('.columncontainer').find('.modSubtotal'),
				$submitButton = $ctx.find('button[type="submit"]'),
				$buttonGroup;

			// Form fields visibility
			$container.children().each(function () {
				var $this = $(this);
				if ($this[0] !== $summary.parent()[0]) {
					if (show) {
						$this.hide();
					} else {
						$this.show();
					}
				}
			});

			if ($colcontainer.length) {
				if (show) {
					$colcontainer.hide();
				} else {
					$colcontainer.show();
				}
			}

			// Submit button visibility
			if ($submitButton.length) {
				if (show) {
					$submitButton.parent().hide();
				} else {
					$submitButton.parent().show();
				}
			}

			// summary visibility
			if (show) {
				mod.updateSummaries();
				$summary.show();
			} else {
				$summary.hide();
			}

			// PEX summary form require different buttons styles
			if (mod.isMobile && $('body').hasClass('pex')) {
				$buttonGroup = $summary.find('.buttonGroup');

				// Remove empty paragraphs and line breaks
				$summary.find('.scs-summary-content p').each(function (index, element) {
					var $element = $(element),
						elementHtml = $element.html();

					if (!elementHtml || elementHtml === '&nbsp;') {
						$element.hide();
					}
				});

				// Cancel
				$buttonGroup.find('.cancel .primary-button').removeClass('primary-button').addClass('secondary-button');

				// Back
				$buttonGroup.find('.back .scs-form-navigation').removeClass('scs-form-navigation').addClass('secondary-button multipage-back-button');
			}
		},

		setFieldValue: function (name, value, createIfNotExistingInForm) {
			//revert 4bf502c6e79029154e2eb993e61cbbd854407dba PORTAL-7022 URAON: Fixed prefilling of form fields that are hidden in multi.wiz.
			//Fix for PORTAL-8265 Attachment don't save
			return this.setFieldValueInContainer(this.formTag, name, value, createIfNotExistingInForm);
		},

		getDataSourceParamsRegExp: function (container) {
			var mod = this;
			if (!mod.dataSourceParamsRegExp) {
				mod.dataSourceParamsRegExp = {};
				$('[data-source-param*="*"]', container.parent()).each(function () {
					var sourceParamName = $(this).data('source-param');
					mod.dataSourceParamsRegExp[sourceParamName] = new RegExp('^' + sourceParamName.replace(/\*/g, '(.*)') + '$', 'i');
				});
			}
			return mod.dataSourceParamsRegExp;
		},

		/**
		 * Search fields data-source-params names with wildcard and match with parameter field name
		 *
		 * Use wildcard '*' for Interaction mail forms: data-source=*group
		 * Values from parameters like x_group, y_group ..., will be set into group field
		 * @param container - form container
		 * @param name - field name
		 */
		getDataSourceParamName: function (container, name) {
			var mod = this,
				dataSourceParamsRegExp = mod.getDataSourceParamsRegExp(container);
			for (var sourceParamName in dataSourceParamsRegExp) {
				if (dataSourceParamsRegExp.hasOwnProperty(sourceParamName)) {
					if (dataSourceParamsRegExp[sourceParamName].test(name)) {
						return sourceParamName;
					}
				}
			}
			return name;
		},

		/**
		 * Sets a value for a field. Can optionally create
		 * a hidden field and append it to the end of the form
		 * if it doesn't exists. HTML decodes the value before
		 * setting it.
		 */
		setFieldValueInContainer: function (container, name, value, createIfNotExistingInForm) {
			//Fix for PORTAL-7022 URAON: Fixed prefilling of form fields that are hidden in multi.wiz. & PORTAL-6604
			//search in parent container for elements in hidden Visibility Control Container

			var el = $('[name="' + name + '"], [name="' + name + '-field"], [data-source-param="' + this.getDataSourceParamName(container, name) + '"]', container.parent()),
				elInContainer = $('[name="' + name + '"], [name="' + name + '-field"], [data-source-param="' + name + '"]', container),
				mod = this,
				valueChanged = false,
				clientvalidation,
				maxLength = Infinity,
				i;

			//hidden element have to insert in form !!!
			if (elInContainer.length === 0 && createIfNotExistingInForm) {
				elInContainer = $('<input type="hidden" name="' + name + '" />');
				container.append(elInContainer);
				el = elInContainer.add(el);
			}

			if (el.length === 0) {
				//nothing found
				return valueChanged;
			}

			if (el.data('is-prefilled') && el.data('prefilled-with') === value) {
				// do not overwrite potential changes made by the user
				debug.log('Tc.Module.ScForm > setFieldValueInContainer > was already prefilled', name, value);
			} else {
				el.data('is-prefilled', true).data('prefilled-with', value);

				if (value instanceof Array || typeof value === 'string') {
					clientvalidation = el.closest('.field').data('clientvalidation');
					if (clientvalidation) {
						maxLength = clientvalidation.maxLength || Infinity;
					}
					debug.log('Tc.Module.ScForm > setFieldValueInContainer', name, value, maxLength);
					if (value instanceof Array) {
						for (i = 0; i < value.length; i += 1) {
							if (typeof value[i] === 'string') {
								try {
									value[i] = decodeURIComponent(value[i]);
								} catch (e) {
								}
								value[i] = value[i].substr(0, maxLength);
							}
						}
					} else if (typeof value === 'string') {
						value = $('<div/>').html(value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')).text();
						try {
							value = decodeURIComponent(value);
						} catch (e) {
						}
						value = value.substr(0, maxLength);
					}
				}
				if ((el.attr('type') === 'checkbox' || el.attr('type') === 'radio') && value !== null) {
					el.each(function () {
						// some values that come from the backend have
						// the character ':' replaced by an empty space,
						// therefore this case has to be checked too
						var $this = $(this),
							valueArray = value instanceof Array ? value : value.split(',');
						if ($this.val() === value ||
							$this.val().replace(':', ' ') === value ||
							$.inArray($this.val(), valueArray) >= 0 ||
							$.inArray($this.val().replace(':', ' '), valueArray) >= 0) {
							$this.prop('checked', true).trigger('updateState');
							// timeout is needed to prevent "stop running script" message in IE8
							setTimeout($.proxy(mod.triggerFieldValueChangedEvent, mod, $this), 0);
							valueChanged = true;
						}
					});
				} else if (el.attr('type') === 'file' && value !== null) {
					if (this.getRequestParameter('action') !== 'copy') { // no prefilling of attachments when copying
						el.trigger('prefill', {items: value.items});
					}
					valueChanged = true;
				} else {
					el.val(value);
					// timeout is needed to prevent "stop running script" message in IE8
					setTimeout($.proxy(mod.triggerFieldValueChangedEvent, mod, el, value), 0);
					valueChanged = true;
				}
			}
			return valueChanged;
		},

		triggerFieldValueChangedEvent: function (element, value) {
			element.trigger('setValue', {value: value}).trigger('change');
		},

		getRequestParameter: function (name) {
			var regex = new RegExp('[?&]' + escapeRegExp(name) + '=([^&]+)'),
				tmpValue = window.location.search.match(regex);
			return tmpValue && tmpValue[1] && decodeURIComponent(tmpValue[1]);
		},

		getPrefillData: function () {
			var mod = this;
			if (!mod.prefillData) {
				// get prefill data embedded in newsletterservice.jsp
				var prefillJson = $('#form-prefill-json').data('prefill-json');
				// init object to hold all merged data keys
				mod.prefillData = $.extend({}, prefillJson);

				// parse query
				mod.setPrefillFormDataFromQuery();

				// parse params after hash sign in url
				mod.setPrefillFormDataFromHash();
				// setup data from this.mapJson
				if (mod.mapJson) {
					mod.setPrefillFormDataFromMap();
				}
				// there is a race condition here, since we do not know
				// which ajax call returns first. If we have same key
				// in both results, only the first will be considered
				// they should return a promise that resolves to data
				if (!prefillJson) {
					mod.lazyPrefillFormData();
				}
				mod.lazyPrefillFormArchiveData();
			}
			return mod.prefillData;
		},

		/* add new keys to prefillData */
		/* skips already known keys */
		addPrefillData: function (data) {
			var mod = this;
			if (!mod.prefillData) {
				mod.prefillData = {};
			}
			if (data) {
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						// skip it if we already have data for this key
						if (mod.prefillData.hasOwnProperty(key)) {
							continue;
						}
						// add this key to our data store
						mod.prefillData[key] = data[key];
					}
				}
				// prefill data now as far as possible
				// called again for newly added data
				mod.prefillFormData();
			}
		},

		prefillFormData: function () {
			this.replaceDefaultValuePlaceholders();

			if (!this.prefillingInProgress) {
				this.prefillingInProgress = true;
				var key,
					data = this.getPrefillData();

				if (data) {
					for (key in data) {
						if (data.hasOwnProperty(key)) {
							if (key === 'randomToken') {
								this.randomFormToken = data[key];
								this.setFieldValue(key, data[key], true);
								this.fire('randomFormToken', {action: 'set', token: data[key]});
								delete data[key];
							} else if (this.setFieldValue(key, data[key])) {
								delete data[key];
							}
						}
					}
				} else {
					// why is this called twice?
					// why do we throw away return?
					this.getPrefillData();
				}
				this.prefillingInProgress = false;
				if (this.restartPrefilling) {
					this.restartPrefilling = false;
					this.prefillFormData();
				}
			} else {
				this.restartPrefilling = true;
			}
		},

		lazyPrefillFormArchiveData: function () {
			var mod = this,
				form = mod.formTag,
				entryId = this.getRequestParameter('entryId'),
				action = this.getRequestParameter('action');
			if (!entryId) {
				entryId = $('input[name=":archiveId"]', mod.$ctx).val();
			}
			if (entryId) {
				this.initReferrerButton();
				if (action === 'edit') {
					this.setFieldValue(':archiveId', entryId, true);
				}
				$.ajax({
					type: 'GET',
					url: form.attr('action').replace('.html', '.formarchive.item.json'),
					cache: false,
					dataType: 'json',
					data: {entryId: entryId},
					success: function (data) {
						if (data.jsonSummary) {
							if (data.attachments && data.attachments.length > 0) {
								for (var i = 0; i < data.attachments.length; i += 1) {
									var attachment = data.attachments[i];
									if (!data.jsonSummary.randomToken) {
										data.jsonSummary.randomToken = attachment.token;
									}
									if (!data.jsonSummary[attachment.fieldName] || typeof data.jsonSummary[attachment.fieldName] === 'string') {
										data.jsonSummary[attachment.fieldName] = {
											items: []
										};
									}
									data.jsonSummary[attachment.fieldName].items.push(attachment);
								}
							}
							mod.addPrefillData(data.jsonSummary);
						}
						if (action === 'edit' && data.lastUpdated) {
							mod.setLastSavedDate(data.lastUpdated);
						}
					}
				}).done(function () {
					mod.autoSubmit();
				});
			}
		},

		lazyPrefillFormData: function () {
			var mod = this,
				prefillUrl = this.$ctx.data('prefill-url'),
				charset = this.$ctx.find('input[name="_charset_"]').val();
			if (prefillUrl) {
				$.ajax({
					url: prefillUrl,
					type: 'get',
					dataType: 'json',
					data: {'_charset_': charset, ':formid': mod.formId, ':formstart': mod.formStart}
				}).done(function (json) {
					mod.addPrefillData(json);
					mod.autoSubmit();
				}).fail(function (jqXHR) {
					debug.log('prefill failed: ' + jqXHR.responseText);
				});
			}
		},

		/**
		 * Prefill form fields with hash parameter values like:
		 * .../myform.html#key=value&foo=bar&zip=1234
		 */
		setPrefillFormDataFromHash: function () {
			if (!this.locationHash) {
				if (!location.hash.length) {
					return;
				}
				this.locationHash = location.href.split('#')[1];
			}
			this.addPrefillData(this.parseQueryString(this.locationHash));
		},

		/**
		 * Prefill form fields with query parameter values like:
		 * .../myform.html?key=value&foo=bar&zip=1234
		 *
		 * Used if query parameter should be remapped to another field
		 */
		setPrefillFormDataFromQuery: function () {
			if (this.$ctx.data('enable-parse-query-parameters') === true && location.search.length) {
				this.addPrefillData(this.parseQueryString(location.search.substring(1)));
			}
		},

		/**
		 * Prefill form fields with values from M@P
		 */
		setPrefillFormDataFromMap: function () {
			var mod = this,
				pattern = new RegExp(escapeRegExp(mod.TPL_PREFIX) + '(' + escapeRegExp(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) + '(\\S+)' + ')' + escapeRegExp(mod.TPL_SUFFIX)), // ${customerDetails_mapFieldName}
				data = {};

			// prefilled text inputs, selects
			mod.$ctx.find('[type="text"], [type="email"], textarea, select').each(function () {
				var $input = $(this),
					defaultValue = $input.data('orig-default-value'),
					currentValue = $input.val() || '',
					value,
					key;

				if (!defaultValue || $input.is('select')) {
					defaultValue = $input.data('default-value') || '';
					$input.data('orig-default-value', defaultValue);
				}

				if ((!$input.is('select')
					&& currentValue.length > 0 && defaultValue.length > 0 && currentValue !== defaultValue)
					|| $input.data('hasChanged')) {
					return;
				}

				var match, replacementCount = 0;
				while ((match = pattern.exec(defaultValue)) !== null) {
					key = match[1];
					value = mod.mapJson[key] || '';
					defaultValue = defaultValue.substr(0, match.index) + value + defaultValue.substr(match.index + match[0].length);
					replacementCount += 1;
				}

				if (!replacementCount) {
					return;
				}

				$input.data('default-value', defaultValue);
				$input.val(defaultValue);

				data[$input.attr('name')] = defaultValue;
			});

			// prefilled checkboxes, radios
			mod.$ctx.find(':checkbox, :radio').each(function () {
				var $input = $(this),
					$field = $input.closest('.field'),
					val = $field.data('orig-default-value'),
					orig = $field.find('input:checked').val() || '',
					replacementCount = 0,
					value, key, keyWithoutPrefix, matchingTitleField, match;

				if (!val) {
					val = $field.data('default-value');
					$field.data('orig-default-value', val);
				}

				val = (orig.length > 0 && orig !== $input.data('default-value')) ? orig : val;

				while ((match = pattern.exec(val)) !== null) {
					key = match[1];
					keyWithoutPrefix = match[2];
					value = mod.mapJson[key] || '';

					if (keyWithoutPrefix === 'title') {
						// special selection method for generder / title field
						matchingTitleField = $field.find(':radio[data-type="title_' + value.toLowerCase() + '"]');
						if (matchingTitleField.length) {
							val = matchingTitleField.val();
						} else {
							break;
						}
					} else {
						val = val.substr(0, match.index) + value + val.substr(match.index + match[0].length);
					}

					replacementCount += 1;
				}

				if (!replacementCount) {
					return;
				}

				$field.data('default-value', val);

				if (val && val.length > 0) {
					data[$input.attr('name')] = val;
					$input.data('default-checked', val === $input.val());
				}

			});

			if ($.isEmptyObject(data)) {
				return;
			}

			mod.addPrefillData(data);
			mod.$ctx.trigger('MapDataPrefilled');
		},

		replaceDefaultValuePlaceholders: function () {
			var mod = this,
				$ctx = mod.$ctx,
				pattern = new RegExp(escapeRegExp(mod.TPL_PREFIX) + '(\\S+)' + mod.TPL_SUFFIX); // ${fieldname}

			debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders', $ctx.find(':input').length);

			// prefilled text inputs
			$('[type="text"], [type="email"], [type="hidden"]', $ctx).each(function () {
				var $input = $(this),
					val = $input.val(),
					match = val && val.match(pattern),
					getValues = function () {
						return this.value;
					},
					fieldname = match && match[1] || '';

				while (match) {
					var placeholderVal =
						$(':input:not(:radio,:checkbox)[name="' + fieldname + '"]').val() ||
						$(':input:radio:checked[name="' + fieldname + '"]').val() ||
						$(':input:checkbox:checked[name="' + fieldname + '"]').map(getValues).get().join(', ') ||
						'';

					debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders > textfield', $input.attr('name'), fieldname, placeholderVal);
					val = val.replace(pattern, placeholderVal);

					if (val.length && val === placeholderVal) {
						break;
					}
					match = val.match(pattern);
					fieldname = match && match[1] || '';
				}

				if (fieldname.indexOf(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) === -1) {
					$input.val(val);
				}

			});

			// prefilled radio buttons, check boxes
			$ctx.find(':checkbox, :radio').each(function () {
				var $input = $(this),
					val = $input.val(),
					$field = $input.closest('.field'),
					defaultValue = $field.data('default-value'),
					match = typeof defaultValue === 'string' && defaultValue.match(pattern);

				if (match) {
					var fieldname = match[1],
						placeholderVal =
							$(':input:radio:checked[name="' + fieldname + '"][value="' + val + '"]').val() ||
							$(':input:checkbox:checked[name="' + fieldname + '"][value="' + val + '"]').val() ||
							$(':input:not(:radio,:checkbox)[name="' + fieldname + '"]').val() ||
							'';

					if (fieldname.indexOf(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) === -1) {
						debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders > radio/checkbox', $input.attr('name'), fieldname, placeholderVal);
						$input.val([placeholderVal]).change();
					}
				}
			});

			// prefilled select drop downs
			$ctx.find('select').each(function () {
				var $input = $(this),
					defaultValue = $input.data('default-value'),
					match = typeof defaultValue === 'string' && defaultValue.match(pattern);

				if (match) {
					var fieldname = match[1],
						placeholderVal =
							$(':input:radio:checked[name="' + fieldname + '"]').val() ||
							$(':input:checkbox:checked[name="' + fieldname + '"]').val() ||
							$(':input:not(:radio,:checkbox)[name="' + fieldname + '"]').val() ||
							'';

					if (fieldname.indexOf(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) === -1) {
						debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders > select dropdown', $input.attr('name'), fieldname, placeholderVal);
						$input.val(placeholderVal).change();
					}
				}
			});
		},

		parseQueryString: function (query) {
			var queryParts, i, queryParam, params = [];
			if (query) {
				queryParts = query.split('&');
				for (i = 0; i < queryParts.length; i += 1) {
					queryParam = queryParts[i].split('=');
					if (queryParam.length === 2) {
						var value = decodeURIComponent((queryParam[1] || '').replace(/\+/g, ' '));
						if (params.hasOwnProperty(queryParam[0])) {
							if (params[queryParam[0]] instanceof Array) {
								params[queryParam[0]].push(value);
							} else {
								params[queryParam[0]] = [params[queryParam[0]], value];
							}
						} else {
							params[queryParam[0]] = value;
						}
					}
				}
			}

			return params;
		}
	}); // end of Tc.Module.extend

	// module vars
	var QTIP_CONFIG = {
		position: {
			my: 'bottom center',
			at: 'top center',
			viewport: $(window), // Keep it on-screen at all times if possible
			adjust: {
				x: 0,
				y: -2
			}
		},
		hide: {
			fixed: true // Helps to prevent the tooltip from hiding occasionally when tracking!
			//,event : 'click' // Uncomment for styling and debugging
		},
		content: {
			title: false,
			text: function () {
				return $(this).data('hint');
			}
		},
		show: {
			event: 'click mouseenter'
		},
		style: {
			classes: ($.fn.qtip.defaults.style.classes || '') + ' scs-callout qtip-shadow qtip-rounded scs-form-qtip'
		}
	};

}(window.Tc.$, window.Tc, window.ScForm, window.debug, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.ScForm.js
// module id = 281
// module chunks = 0